import type { Coupon } from '@epilot/journey-logic-commons'
import { useMemo } from 'react'

const DEFAULT_DISCOUNTS = []
const DEFAULT_CASHBACKS = []

export const useCategorizedCoupons = (coupons: Coupon[] | undefined) => {
  const discounts = useMemo(
    () =>
      coupons?.filter((coupon) => coupon.category === 'discount') ??
      DEFAULT_DISCOUNTS,
    [coupons]
  )

  const cashbacks = useMemo(
    () =>
      coupons?.filter((coupon) => coupon.category === 'cashback') ??
      DEFAULT_CASHBACKS,
    [coupons]
  )

  return { discounts, cashbacks }
}
